require('./mortgageRequestAppraisalPayView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ helpers
const { formatText, getFinalTitle, getLanguage } = require('core/i18n').i18n;
const { md5 } = require('utilities/hash');

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { ContentBox } = require('commonsComponents/contentBox');

// @ components
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const MortgageRequestTPVIframe = require('components/mortgageRequest/mortgageRequestTPVIframe/mortgageRequestTPVIframe');
const MortgageRequestPayMarketingCountry = require('components/mortgageRequest/mortgageRequestPayMarketingCountry/mortgageRequestPayMarketingCountry');

// @ constants
const { mortgageTPVIframe } = require('constants/mortgageTPVIframe/mortgageTPVIframe');
const { PAYMENT_AMOUNT_IDENTIFIER } = require('constants/index');

class MortgageRequestAppraisalPayView extends React.Component {
    constructor(props) {
        super(props);
        this.redirectOnInmueblesEmpty = this.redirectOnInmueblesEmpty.bind(this);
    }

    getMappingBreacrumb() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");

        return [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestAppraisalRequest-title'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);
    }

    handleOnCancelAddAppraisal(evt) {
        evt.preventDefault();
        this.props.history.push('/myprofile/mortgage/panel');
    }

    handleMerchantOrder(immEstates, mortgageRequestState) {
        let estatesListData = immEstates.get('list').toJS();
        let expId = mortgageRequestState.toJS();
        let id_imm = '';
        estatesListData.forEach((element, index) => {
            const itHasOnlyOneItem = estatesListData.length === 1;
            const itIsTheLastItem = (estatesListData.length - 1) === index;

            if (itHasOnlyOneItem || itIsTheLastItem) {
                id_imm += element.id;
            } else {
                id_imm += element.id + '|';
            }
        });
        let MERCHANT_ORDER = 'TS' + expId.idExpediente + '_' + id_imm;
        return MERCHANT_ORDER
    }

    handleMerchantAmount(int) {
        const amountIdentifier = getLanguage().toLocaleUpperCase() === 'EN' ? PAYMENT_AMOUNT_IDENTIFIER.EN : PAYMENT_AMOUNT_IDENTIFIER.ES
        if (int.indexOf(amountIdentifier) > 0) {
            let amount = int.split(amountIdentifier);
            int = parseInt(amount[0] + amount[1]);
            return int;
        } else if (parseInt(int) % 1 == 0) {
            int = parseInt(int) + '00'
            return parseInt(int);
        }
    }

    redirectOnInmueblesEmpty(immEstates) {
        if (!immEstates.get('hasBeenFetched') && immEstates.get('list').isEmpty()) {
            this.props.history.push('/myprofile/mortgage/property-value-defined');
        }
    }

    render() {
        const {
            immEstates,
            immFlagBasedFeatures,
            immPayment,
            mortgageRequestState,
        } = this.props;
        this.redirectOnInmueblesEmpty(immEstates);
        const MERCHANT_ORDER = this.handleMerchantOrder(immEstates, mortgageRequestState);
        const MERCHANT_AMOUNT = this.handleMerchantAmount(`${MortgageRequestCurrencyHelp({ currency: immPayment.get('appraisalCost'), addCurrencySymbol : true })}`);
        const signature = md5(`${mortgageTPVIframe.MERCHANT_MERCHANTCODE}${mortgageTPVIframe.MERCHANT_TERMINAL}${mortgageTPVIframe.OPERATION}${MERCHANT_ORDER}${MERCHANT_AMOUNT}${mortgageTPVIframe.MERCHANT_CURRENCY}${mortgageTPVIframe.PASSWORD}`);

        return (
            <div className="mortgage-request-appraisal-pay-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={this.getMappingBreacrumb()}
                                finalTitle={getFinalTitle('mortgagePropertyValue-title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-offset-2 col-xs-8">
                                <ContentBox>
                                    <div className="mortgage-request-appraisal-pay-view__body-block-1">
                                        <div className="mortgage-request-appraisal-pay-view__body-block-1--street-1">
                                            {formatText('mortgageRequestPay-infoTextNoClient')}
                                        </div>
                                        <div className="mortgage-request-appraisal-pay-view__body-block-1--street-2">
                                            <MortgageRequestTPVIframe
                                                signature={signature}
                                                MERCHANT_ORDER={MERCHANT_ORDER}
                                                MERCHANT_AMOUNT={MERCHANT_AMOUNT}
                                                MERCHANT_MERCHANTCODE={mortgageTPVIframe.MERCHANT_MERCHANTCODE}
                                                MERCHANT_TERMINAL={mortgageTPVIframe.MERCHANT_TERMINAL}
                                                OPERATION={mortgageTPVIframe.OPERATION}
                                                MERCHANT_CURRENCY={mortgageTPVIframe.MERCHANT_CURRENCY}
                                                SECURE={mortgageTPVIframe.SECURE}
                                                immFlagBasedFeatures={immFlagBasedFeatures}
                                            />
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="mortgage-request-appraisal-pay-view__footer">
                                        <div className="col-md-5 col-md-offset-8">
                                            <a href="#" className="ok-link" onClick={(e) => this.handleOnCancelAddAppraisal(e)}>
                                                {formatText('mortgageRequestAppraisalRequest-appraisalRequestReturnToPanel')}
                                            </a>
                                        </div>
                                    </div>
                                </ContentBox>
                                <MortgageRequestPayMarketingCountry />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports.constructor = MortgageRequestAppraisalPayView;

MortgageRequestAppraisalPayView.propTypes = {
    history: PropTypes.object.isRequired,
    immEstates: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    mortgageRequestState: PropTypes.object.isRequired,
};

module.exports.MortgageRequestAppraisalPayView = connect(
    state => ({
        immEstates: state.mortgageRequestInmuebles,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immPayment: state.mortgageRequestPayment,
        mortgageRequestState: state.mortgageRequestState,
        immGlobalPosition: state.globalPosition,
    }), null
)(withRouter(MortgageRequestAppraisalPayView));
